import { Box, Button, CircularProgress, Grid, TextField, Typography } from "@mui/material";
import Modal from "@mui/material/Modal";
import { useState } from 'react'
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import './index.scss'
import { useDeleteNoteMutation } from "../../../../../graphql/generated/graphql";
import { setAlertDescription } from "../../../../hooks/actions";

const style = {
    position: "absolute" as const,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "20px",
    backgroundColor: 'white',
};

interface ModalDeleteNoteProp {
    open: boolean,
    handleModal: (open: boolean, needEvent: boolean, event?: any) => void
    idNoteToDelete: number,
    refetch: any
}

const ModalDeleteNote = (props: ModalDeleteNoteProp) => {

    const { open, handleModal, idNoteToDelete, refetch } = props
    const [isLoading, setIsLoading] = useState(false);
    const [deleteNote] = useDeleteNoteMutation();

    const deleteNotes = async () => {
        setIsLoading(true)
        if (idNoteToDelete) {
            try {
                await deleteNote({
                    variables: {
                        note_id: idNoteToDelete,
                    },
                }).then((res) => {
                    setIsLoading(false);
                    setAlertDescription({
                        open: true,
                        message: 'The Note has been updated succesfully',
                        severity: 'success',
                    })
                    if (refetch) {
                        refetch();
                    }
                    handleModal(false, false);
                })
            } catch (err) {
                console.error(err);
            }
        } else {
            setAlertDescription({
                open: true,
                message: 'Error, try again',
                severity: 'error',
            })
        }
    }

    return (
        <Modal
            open={open}
            onClose={(e) => handleModal(false, true, e)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Box
                    sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "space-around",
                        flexDirection: 'column',
                        alignItems: "center",
                        paddingY: '20px',
                        paddingX: '24px'
                    }}
                >
                    <Typography
                        component="h1"
                        variant="h3"
                        sx={{
                            mb: 2,
                            fontWeight: 500,
                        }}
                    >
                        Are you sure about eliminate this note?
                    </Typography>
                    <Grid
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <Button
                            sx={{
                                width: '20%',
                                marginRight: 1,
                                height: '32px'
                            }}
                            variant="contained"
                            onClick={deleteNotes}
                        >
                            {isLoading ?
                                <CircularProgress
                                    color="secondary"
                                    size={20}
                                /> : 'Delete'}
                        </Button>
                        <Button
                            color="secondary"
                            sx={{
                                width: '20%',
                                marginRight: 1,
                                height: '32px'
                            }}
                            variant="contained"
                            onClick={() => handleModal(false, false)}
                        >
                            Cancel
                        </Button>
                    </Grid>
                </Box>
            </Box>
        </Modal>
    )
}

export default ModalDeleteNote